import http from "@/utils/http";
/**
 *  @parms resquest 请求地址
 */
let resquest = "https://apipxb.1v1jy.com/api";
// let resquest = "https://t-apipxb.1v1jy.com/api";
// let resquest = "http://localhost:50245/api";

// let resquest = "https://pxbapi.getdreamstar.com/api";

// let resquest = "https://pxbapi.yidiantangedu.com/api";

let parentUrl = "https://pxbjz.1v1jy.com/#/";
// let parentUrl = "https://pxbjz.yiqun169.com/#/";
// let parentUrl = "https://pxbjz.yidiantangedu.com/#/";

export default {
  upImg: `${resquest}/common/upImg`,
  login(param) {
    //登录
    return http.post(`${resquest}/user/smsLoginH5`, param);
  },
  SendSms(param) {
    //获取短信验证码
    return http.post(`${resquest}/user/smsCode`, param);
  },
  loginInfoH5(param) {
    //获取用户信息
    return http.post(`${resquest}/user/loginInfoH5`, param);
  },
  classTimesGetMy(param) {
    //获取课次信息(周)
    return http.post(`${resquest}/educational/classTimesGetMy`, param);
  },
  classTimesGetMyOt(param) {
    //获取课次信息(时间)
    return http.post(`${resquest}/educational/classTimesGetMyOt`, param);
  },
  classTimesGetView(param) {
    //通过ID获取课次基本信息
    return http.post(`${resquest}/educational/classTimesGetView`, param);
  },
  StudentLeaveAboutClassCheckSignGet(param) {
    return http.post(
      `${resquest}/student/StudentLeaveAboutClassCheckSignGet`,
      param
    );
  },
  classBascGet(param) {
    //获取班级基本信息（点名用）
    return http.post(`${resquest}/educational/classBascGet`, param);
  },
  classTimesGetEditView(param) {
    //获取课次基本信息（点名用）
    return http.post(`${resquest}/educational/classTimesGetEditView`, param);
  },
  classTimesStudentGet(param) {
    //获取课次上课学员信息（点名用）
    return http.post(`${resquest}/educational/classTimesStudentGet`, param);
  },
  studentCourseSurplusGet(param) {
    //获取学员课程剩余课时信息（点名用）
    return http.post(`${resquest}/student/studentCourseSurplusGet`, param);
  },
  teacherClassTimetableCountGetMy(param) {
    //获取课表课次统计信息
    return http.post(
      `${resquest}/educational/teacherClassTimetableCountGetMy`,
      param
    );
  },
  classCheckSign(param) {
    //提交点名信息（点名用）
    return http.post(`${resquest}/educational/classCheckSign`, param);
  },
  studentGetPaging(param) {
    //分页获取学员列表
    return http.post(`${resquest}/student/studentGetPaging`, param);
  },
  classRecordGetPagingH5(param) {
    //分页获取上课记录
    return http.post(`${resquest}/educational/classRecordGetPagingH5`, param);
  },
  classRecordGet(param) {
    //通过ID获取上课记录详情基本信息
    return http.post(`${resquest}/educational/classRecordGet`, param);
  },
  classRecordStudentGet(param) {
    //通过ID获取上课记录详情学员信息
    return http.post(`${resquest}/educational/classRecordStudentGet`, param);
  },
  classMyGet(param) {
    //获取当前老师所在的班级信息（未排课直接点名）
    return http.post(`${resquest}/educational/classMyGet`, param);
  },
  classTimesClassStudentGet(param) {
    //获取班级学员信息(未排课直接点名)
    return http.post(
      `${resquest}/educational/classTimesClassStudentGet`,
      param
    );
  },
  studentCourseOwnerGetPaging(param) {
    //分页获取课程学员
    return http.post(`${resquest}/student/studentCourseOwnerGetPaging`, param);
  },
  userGetAuthorizeUrl(param) {
    //获取用户微信授权地址
    return http.post(`${resquest}/user/userGetAuthorizeUrl`, param);
  },
  userGetAuthorizeUrl2(param) {
    //获取微信授权地址(需要凭证)
    return http.post(`${resquest}/user/userGetAuthorizeUrl2`, param);
  },
  userBindingWeChat(param) {
    //保存用户微信授权信息
    return http.post(`${resquest}/user/userBindingWeChat`, param);
  },
  tenantConfigGet(param) {
    //获取用户微信授权地址
    return http.post(`${resquest}/basic/tenantConfigGet`, param);
  },
  getTenantInfoH5ByNo(param) {
    //获取机构信息（通过机构编码）
    return http.post(`${resquest}/basic/getTenantInfoH5ByNo`, param);
  },
  getTenantInfoH5(param) {
    //获取机构信息
    return http.post(`${resquest}/basic/getTenantInfoH5`, param);
  },
  activeHomeworkGetPaging(param) {
    //分页获取作业信息
    return http.post(`${resquest}/interaction/activeHomeworkGetPaging`, param);
  },
  activeHomeworkAdd(param) {
    //新增单次作业
    return http.post(`${resquest}/interaction/activeHomeworkAdd`, param);
  },
  activeHomeworkGetBasc(param) {
    //通过ID获取作业的基本信息
    return http.post(`${resquest}/interaction/activeHomeworkGetBasc`, param);
  },
  activeHomeworkStudentGetAnswered(param) {
    //通过ID获取作业学生作答信息(已提交)
    return http.post(
      `${resquest}/interaction/activeHomeworkStudentGetAnswered`,
      param
    );
  },
  activeHomeworkStudentGetUnanswered(param) {
    //通过ID获取作业学生作答信息(未提交)
    return http.post(
      `${resquest}/interaction/activeHomeworkStudentGetUnanswered`,
      param
    );
  },
  activeHomeworkDel(param) {
    //删除作业
    return http.post(`${resquest}/interaction/activeHomeworkDel`, param);
  },
  activeHomeworkCommentAdd(param) {
    //添加作业评语（或回复）
    return http.post(`${resquest}/interaction/activeHomeworkCommentAdd`, param);
  },
  activeHomeworkCommentDel(param) {
    //删除评语
    return http.post(`${resquest}/interaction/activeHomeworkCommentDel`, param);
  },
  classGetPaging(param) {
    //获取班级
    return http.post(`${resquest}/educational/classGetPaging`, param);
  },
  classStudentGet(param) {
    //获取班级学员
    return http.post(`${resquest}/educational/classStudentGet`, param);
  },
  upFileBase64(param) {
    //上传文件
    return http.post(`${resquest}/common/upFileBase64`, param, 2 * 60 * 1000);
  },
  studentGet(param) {
    //学员详情
    return http.post(`${resquest}/student/studentGet`, param);
  },
  studentCourseDetailGet(param) {
    //报读课程
    return http.post(`${resquest}/student/studentCourseDetailGet`, param);
  },
  classTimesGetOfWeekTime(param) {
    //学员课表
    return http.post(`${resquest}/educational/classTimesGetOfWeekTime`, param);
  },
  studentTrackLogGetList(param) {
    //学员跟进记录
    return http.post(`${resquest}/student/studentTrackLogGetList`, param);
  },
  orderGetPaging(param) {
    //学员订单记录
    return http.post(`${resquest}/hisData/orderGetPaging`, param);
  },
  orderGetDetail(param) {
    //学员订单详情
    return http.post(`${resquest}/hisData/OrderGetDetail`, param);
  },
  OrderReturnLogGet(param) {
    return http.post(`${resquest}/hisData/OrderReturnLogGet`, param);
  },
  OrderTransferCoursesLogGet(param) {
    return http.post(`${resquest}/hisData/OrderTransferCoursesLogGet`, param);
  },
  orderTransferCoursesGetDetail(param) {
    //转课记录详情
    return http.post(
      `${resquest}/hisData/orderTransferCoursesGetDetail`,
      param
    );
  },
  studentClassRecordGetPaging(param) {
    //学员上课记录
    return http.post(
      `${resquest}/educational/studentClassRecordGetPaging`,
      param
    );
  },
  studentPointLogPaging(param) {
    //学员积分记录
    return http.post(`${resquest}/student/studentPointLogPaging`, param);
  },
  getExchangeLogDetailPaging(param) {
    //学员兑换记录
    return http.post(`${resquest}/marketing/getExchangeLogDetailPaging`, param);
  },
  studentCouponsNormalGet(param) {
    //学员优惠券(未使用)
    return http.post(`${resquest}/marketing/studentCouponsNormalGet`, param);
  },
  studentCouponsUsedGet(param) {
    //学员优惠券(已使用)
    return http.post(`${resquest}/marketing/studentCouponsUsedGet`, param);
  },
  studentCouponsExpiredGet(param) {
    //学员优惠券(已过期)
    return http.post(`${resquest}/marketing/studentCouponsExpiredGet`, param);
  },
  gradeGet(param) {
    //获取年级
    return http.post(`${resquest}/basic/gradeGet`, param);
  },
  studentRelationshipGet(param) {
    //获取人物关系
    return http.post(`${resquest}/basic/studentRelationshipGet`, param);
  },
  userGetPaging(param) {
    //获取员工
    return http.post(`${resquest}/user/userGetPaging`, param);
  },
  studentTagGet(param) {
    //学员标签
    return http.post(`${resquest}/basic/studentTagGet`, param);
  },
  studentAdd(param) {
    //添加学员
    return http.post(`${resquest}/student/studentAdd`, param);
  },
  studentEdit(param) {
    //修改学员
    return http.post(`${resquest}/student/studentEdit`, param);
  },
  studentGetForEdit(param) {
    return http.post(`${resquest}/student/studentGetForEdit`, param);
  },
  studentExtendFieldInit(param) {
    //自定义属性
    return http.post(`${resquest}/student/studentExtendFieldInit`, param);
  },
  courseGetPaging(param) {
    //获取课程
    return http.post(`${resquest}/product/courseGetPaging`, param);
  },
  goodsGetPaging(param) {
    //获取物品
    return http.post(`${resquest}/product/goodsGetPaging`, param);
  },
  costGetPaging(param) {
    //获取费用
    return http.post(`${resquest}/product/costGetPaging`, param);
  },
  couponsStudentGetCanUse(param) {
    //获取学员可用优惠券
    return http.post(`${resquest}/marketing/couponsStudentGetCanUse`, param);
  },
  tudentEnrolment(param) {
    //报名
    return http.post(`${resquest}/student/studentEnrolment`, param);
  },
  userCheck(param) {
    //用户校验
    return http.post(`${resquest}/user/userCheck`, param);
  },
  userGetCurrentTenant(param) {
    //[切换机构]获取当前机构信息
    return http.post(`${resquest}/user/userGetCurrentTenant`, param);
  },
  userGetTenants(param) {
    //[切换机构]获取用户机构列表
    return http.post(`${resquest}/user/userGetTenants`, param);
  },
  userTenantEntrance(param) {
    //[切换机构]切换登录机构
    return http.post(`${resquest}/user/userTenantEntrance`, param);
  },
  tenantToDoThingGet(param) {
    //获取代办事项信息
    return http.post(`${resquest}/hisData/tenantToDoThingGet`, param);
  },
  upUserSimple(param) {
    //修改用户信息
    return http.post(`${resquest}/user/upUserSimple`, param);
  },
  upImg() {
    return `${resquest}/common/upImg`;
  }
};
export function getParentUrl() {
  return parentUrl;
}
export function apiPost(url, param) {
  return http.post(`${resquest + url}`, param);
}
export function upImg() {
  return `${resquest}/common/upImg`;
}
//上传录音
export function uploadMyVoice(param) {
  return http.post(`${resquest + "/common/UploadWxMedia"}`, param);
}

export function GetClassInSeatNum() {
  return [
    {
      value: 1,
      label: "1v1",
    },
    {
      value: 2,
      label: "1v2",
    },
    {
      value: 3,
      label: "1v3",
    },
    {
      value: 4,
      label: "1v4",
    },
    {
      value: 5,
      label: "1v5",
    },
    {
      value: 6,
      label: "1v6",
    },
    {
      value: 7,
      label: "1v7",
    },
    {
      value: 8,
      label: "1v8",
    },
    {
      value: 9,
      label: "1v9",
    },
    {
      value: 10,
      label: "1v10",
    },
    {
      value: 11,
      label: "1v11",
    },
    {
      value: 12,
      label: "1v12",
    },
  ];
}

export function GetClassLeaveChargeSetPartTimeType() {
  return [
    {
      value: 0,
      label: "不限时间"
    },
    {
      value: 1,
      label: "每周"
    },
    {
      value: 2,
      label: "每月"
    },
    {
      value: 3,
      label: "每年"
    }
  ];
}
export function payType() {
  return [
    {
      value: 0,
      text: "支付宝"
    },
    {
      value: 1,
      text: "微信支付"
    },
    {
      value: 2,
      text: "现金支付"
    },
    {
      value: 3,
      text: "银联支付"
    },
    {
      value: 4,
      text: "POS机"
    },
    {
      value: 99,
      text: "其他支付"
    }
  ];
}
export function GetEchartsPieDefaultColor() {
  return [
    "#89c3eb",
    "#98d98e",
    "#00a3af",
    "#84a2d4",
    "#e5abbe",
    "#93b69c",
    "#8491c3",
    "#895b8a",
    "#cc7eb1",
    "#c4a3bf",
    "#9790a4",
    "#a58f86",
    "#888084",
    "#80989b",
    "#6c848d",
    "#a0d8ef",
    "#5a79ba",
    "#507ea4",
    "#867ba9",
    "#9079ad",
    "#3b7960",
    "#9ba88d",
    "#8c8861",
    "#8f8667",
    "#b68d4c",
    "#d4acad",
    "#c37854",
    "#ddbb99",
    "#f9c89b",
    "#f7b977",
    "#d57c6b",
    "#475950",
    "#74325c"
  ];
}
export function menusList(index) {
  let arr = [
    "",
    "rollCallTime",
    "rollCallRecord",
    "evaluateClass",
    "homeWorkList",
    "studentList",
    "leaveApplication",
    "tryClassApply",
    "timetable",
    "schoolTimetable",
    "archives",
    "followUpRecord",
    "tryClassRecord",
    "orderPayhistory",
    "classCancelRecord",
    "inExMgr",
    "salaryMgr",
    "students",
    "sales",
    "academic",
    "financeData",
    "warningMgr",
    "gift",
    "giveOut",
    "classMgr",
    "notice",
    "studentCourseFastDeClassTimes",
    "studentCourseFastDeClassTimesBatch",
    "studentCourse",
    "classRecordStudent",
    "attendanceRecord",
    "achievementList",
    "businessSummary",
    "scanStudentCode",
    "checkByCode",
    "textBookList",
    "CourseMgr",
    "recharge",
    "ItemsAndExpenses",
    "studentGetBuyCode",
    "StaffManagement"
  ];
  return arr[index];
}

export function GetAllDurationHour() {
  var res = [];
  for (var i = 0; i <= 12; i++) {
    res.push({
      value: i,
      label: i.toString(),
    });
  }
  return res;
}

export function GetAllDurationMinute() {
  var res = [];
  for (var i = 0; i < 60; i += 5) {
    res.push({
      value: i,
      label: i.toString(),
    });
  }
  return res;
}

export function GetAllDurationHour2() {
  var res = [];
  for (var i = 0; i <= 8; i++) {
    res.push({
      value: i,
      label: i.toString(),
    });
  }
  return res;
}

export function GetAllDurationMinute2() {
  var res = [];
  for (var i = 0; i < 60; i += 5) {
    res.push({
      value: i,
      label: i.toString(),
    });
  }
  return res;
}

export function GetClassTuleEndType() {
  return [
    {
      value: 0,
      label: "不结束"
    },
    {
      value: 1,
      label: "限日期"
    },
    {
      value: 2,
      label: "限次数"
    }
  ];
}

export function GetStudentType() {
  return [
    {
      value: 0,
      label: "潜在学员"
    },
    {
      value: 1,
      label: "在读学员"
    },
    {
      value: 2,
      label: "历史学员"
    }
  ];
}

export function GetStudentType2() {
  return [
    {
      value: -1,
      label: "全体学员"
    },
    {
      value: 0,
      label: "潜在学员"
    },
    {
      value: 1,
      label: "在读学员"
    },
    {
      value: 2,
      label: "历史学员"
    }
  ];
}

export function GetStudentTrackStatus() {
  return [
    {
      value: 0,
      label: "待跟进"
    },
    {
      value: 1,
      label: "跟进中"
    },
    {
      value: 2,
      label: "已约课"
    },
    {
      value: 3,
      label: "已体验"
    },
    {
      value: 4,
      label: "已失效"
    }
  ];
}

export function GetWeek() {
  return [
    {
      value: 1,
      label: "一"
    },
    {
      value: 2,
      label: "二"
    },
    {
      value: 3,
      label: "三"
    },
    {
      value: 4,
      label: "四"
    },
    {
      value: 5,
      label: "五"
    },
    {
      value: 6,
      label: "六"
    },
    {
      value: 0,
      label: "日"
    }
  ];
}

//操作权限
export function defaultActionPermission() {
  return {
    "1": false,
    "2": false,
    "3": false,
    "4": false,
    "5": false,
    "6": false,
    "7": false,
    "8": false,
    "9": false,
    "10": false,
    "11": false,
    "12": false,
    "13": false,
    "14": false,
    "15": false,
    "16": false,
    "17": false,
    "18": false,
    "19": false,
    "20": false,
    "21": false,
    "22": false,
    "23": false,
    "24": false,
    "25": false,
    "26": false,
    "27": false,
    "28": false,
    "29": false,
    "30": false,
    "31": false,
    "32": false,
    "33": false,
    "34": false,
    "35": false,
    "36": false,
    "37": false,
    "38": false,
    "39": false,
    "40": false,
    "41": false,
    "42": false,
    "43": false,
    "44": false,
    "45": false,
    "46": false,
    "47": false,
    "48": false,
    "49": false,
    "50": false,
    "51": false,
    "52": false,
    "53": false,
    "54": false,
    "55": false,
    "56": false,
    "57": false,
    "58": false,
    "59": false,
    "60": false,
    "61": false,
    "62": false,
    "63": false,
    "64": false,
    "65": false,
    "66": false,
    "67": false,
    "68": false,
    "69": false,
    "70": false,
    "71": false,
    "72": false,
    "73": false,
    "74": false,
    "75": false,
    "76": false,
    "77": false,
    "78": false,
    "79": false,
    "80": false,
    "81": false,
    "82": false,
    "83": false,
    "84": false,
    "85": false,
    "86": false,
    "87": false,
    "88": false,
    "89": false,
    "90": false,
    "91": false,
    "92": false,
    "93": false,
    "94": false,
    "95": false,
    "96": false,
    "97": false,
    "98": false,
    "99": false,
    "100": false,
    "101": false,
    "102": false,
    "103": false,
    "104": false,
    "105": false,
    "106": false,
    "107": false,
    "108": false,
    "109": false,
    "110": false,
    "111": false,
    "112": false,
    "113": false,
    "114": false,
    "115": false,
    "116": false,
    "117": false,
    "118": false,
    "119": false,
    "120": false,
    "121": false,
    "122": false,
    "123": false,
    "124": false,
    "125": false,
    "126": false,
    "127": false,
    "128": false,
    "129": false,
    "130": false
  };
}

//页面
export function defaultPagePermission() {
  return {
    "1": false,
    "2": false,
    "3": false,
    "4": false,
    "5": false,
    "6": false,
    "7": false,
    "8": false,
    "9": false,
    "10": false,
    "11": false,
    "12": false,
    "13": false,
    "14": false,
    "15": false,
    "16": false,
    "17": false,
    "18": false,
    "19": false,
    "20": false,
    "21": false,
    "22": false,
    "23": false,
    "24": false,
    "25": false,
    "26": false,
    "27": false,
    "28": false,
    "29": false,
    "30": false,
    "31": false,
    "32": false,
    "33": false,
    "34": false,
    "35": false,
    "36": false,
    "37": false,
    "38": false,
    "39": false,
    "40": false,
    "41": false,
    "42": false,
    "43": false,
    "44": false,
    "45": false,
    "46": false,
    "47": false,
    "48": false,
    "49": false,
    "50": false,
    "51": false,
    "52": false,
    "53": false,
    "54": false,
    "55": false,
    "56": false,
    "57": false,
    "58": false,
    "59": false,
    "60": false,
    "61": false,
    "62": false,
    "63": false,
    "64": false,
    "65": false,
    "66": false,
    "67": false,
    "68": false,
    "69": false,
    "70": false,
    "71": false,
    "72": false,
    "73": false,
    "74": false,
    "75": false,
    "76": false,
    "77": false,
    "78": false,
    "79": false,
    "80": false,
    "81": false,
    "82": false,
    "83": false,
    "84": false,
    "85": false,
    "86": false,
    "87": false,
    "88": false,
    "89": false,
    "90": false,
    "91": false,
    "92": false,
    "93": false,
    "94": false,
    "95": false,
    "96": false,
    "97": false,
    "98": false,
    "99": false,
    "100": false,
    "101": false,
    "102": false,
    "103": false,
    "104": false,
    "105": false,
    "106": false,
    "107": false,
    "108": false,
    "109": false,
    "110": false,
    "111": false,
    "112": false,
    "113": false,
    "114": false,
    "115": false,
    "116": false,
    "117": false,
    "118": false,
    "119": false,
    "120": false
  };
}

/**
 * 套餐状态
 */
export const setMealStatus = [
  {
    value: 0,
    text: "启用"
  },
  {
    value: 1,
    text: "禁用"
  }
];

/**
 * 套餐课程赠送数量单位
 */
export const setMealGiveNumUnitList = [
  {
    value: 1,
    label: "天"
  },
  {
    value: 2,
    label: "月"
  }
];

/**
 * 套餐优惠类型
 */
export const discountTypeList = [
  {
    value: 1,
    text: "直减"
  },
  {
    value: 2,
    text: "折扣"
  }
];

/**
 * 课程状态
 */
export const courseStatus = [
  {
    value: 0,
    text: "启用"
  },
  {
    value: 1,
    text: "禁用"
  }
];

/**
 * 课程类型
 */
export const courseType = [
  {
    value: 0,
    text: "一对多"
  },
  {
    value: 1,
    text: "一对一"
  }
];

/**
 * 收费规则按课时收费的周期列表
 */
export const courseRuleHourPeriodList = [
  {
    value: 1,
    text: "天"
  },
  {
    value: 2,
    text: "月"
  },
  {
    value: 3,
    text: "年"
  },
  {
    value: 4,
    text: "固"
  }
];

/**
 * 收费规则按周期收费的周期列表
 */
export const courseRulePeriodPeriodList = [
  {
    value: 1,
    text: "周"
  },
  {
    value: 2,
    text: "月"
  }
];

export function GetClassStudentType() {
  return [
    {
      value: 0,
      name: "班级学员"
    },
    {
      value: 1,
      name: "临时学员"
    },
    {
      value: 2,
      name: "试听学员"
    },
    {
      value: 3,
      name: "补课学员"
    }
  ];
}

export function GetClassRecordStatus() {
  return [
    {
      value: 0,
      name: "正常"
    },
    {
      value: 1,
      name: "已撤销"
    }
  ];
}
export function GetStudentCheckStatus() {
  return [
    {
      value: 0,
      name: "到课"
    },
    {
      value: 1,
      name: "迟到"
    },
    {
      value: 2,
      name: "请假"
    },
    {
      value: 3,
      name: "未到"
    }
  ];
}

export function GetTrueFalse() {
  return [
    {
      value: 0,
      name: "否"
    },
    {
      value: 1,
      name: "是"
    }
  ];
}

export function GetLastGoClassTimeDay() {
  return [
    {
      value: 5,
      label: "超过5天未上课"
    },
    {
      value: 10,
      label: "超过10天未上课"
    },
    {
      value: 15,
      label: "超过15天未上课"
    },
    {
      value: 20,
      label: "超过20天未上课"
    },
    {
      value: 25,
      label: "超过25天未上课"
    },
    {
      value: 30,
      label: "超过30天未上课"
    },
    {
      value: 60,
      label: "超过60天未上课"
    }
  ];
}
export function GetStudentCourseStatus() {
  return [
    {
      value: 0,
      label: "正常"
    },
    {
      value: 1,
      label: "已停课"
    },
    {
      value: 2,
      label: "已结课"
    }
  ];
}

export function GetBindingWechatStatus() {
  return [
    {
      value: 0,
      label: "未绑定"
    },
    {
      value: 1,
      label: "已绑定"
    }
  ];
}

export function GetIncomeLogProjectSystemType() {
  return [
    {
      value: -1,
      text: "报名/续费"
    },
    {
      value: -2,
      text: "报名补缴"
    },
    {
      value: -3,
      text: "销售退单"
    },
    {
      value: -4,
      text: "转课"
    },
    {
      value: -5,
      text: "账户充值"
    },
    {
      value: -6,
      text: "账户退款"
    },
    {
      value: -7,
      text: "员工工资"
    },
    {
      value: -8,
      text: "推荐学员注册"
    },
    { value: -9, text: "推荐学员消费" },
    {
      value: -10,
      text: "安排学员试听"
    },
    {
      value: -11,
      text: "申请试听"
    },
    {
      value: -12,
      text: "在线购充值卡"
    }
  ];
}

export function GetIncomeLogStatus() {
  return [
    {
      value: 0,
      text: "正常"
    },
    {
      value: 1,
      text: "已作废"
    }
  ];
}

export function GetIncomeLogType() {
  return [
    {
      value: 0,
      text: "收入"
    },
    {
      value: 1,
      text: "支出"
    }
  ];
}

export function GetBirthdayNearDay() {
  return [
    {
      value: 0,
      label: "今日生日"
    },
    {
      value: 7,
      label: "7天内生日"
    },
    {
      value: 15,
      label: "15天内生日"
    },
    {
      value: 30,
      label: "30天内生日"
    },
    {
      value: 60,
      label: "60天内生日"
    }
  ];
}

export function GetMonths() {
  return [
    {
      value: 1,
      label: "一月"
    },
    {
      value: 2,
      label: "二月"
    },
    {
      value: 3,
      label: "三月"
    },
    {
      value: 4,
      label: "四月"
    },
    {
      value: 5,
      label: "五月"
    },
    {
      value: 6,
      label: "六月"
    },
    {
      value: 7,
      label: "七月"
    },
    {
      value: 8,
      label: "八月"
    },
    {
      value: 9,
      label: "九月"
    },
    {
      value: 10,
      label: "十月"
    },
    {
      value: 11,
      label: "十一月"
    },
    {
      value: 12,
      label: "十二月"
    }
  ];
}

export function GetStudentIntentionLevel() {
  return [
    {
      value: 0,
      label: "低"
    },
    {
      value: 1,
      label: "中"
    },
    {
      value: 2,
      label: "高"
    }
  ];
}

export function GetOrderCheckStatus() {
  return [
    {
      value: 0,
      label: "未审核"
    },
    {
      value: 1,
      label: "已审核"
    }
  ];
}

export function GetMallProductType() {
  return [
    {
      value: 0,
      label: "课程"
    },
    {
      value: 1,
      label: "物品"
    },
    {
      value: 2,
      label: "费用"
    },
    {
      value: 3,
      label: "套餐"
    },
    {
      value: 4,
      label: "充值卡"
    }
  ];
}

export function GetOrderBuyType() {
  return [
    {
      value: 0,
      label: "新报"
    },
    {
      value: 1,
      label: "续报"
    },
    {
      value: 2,
      label: "扩科"
    }
  ];
}

export function GetOrderProductType() {
  return [
    {
      value: 0,
      label: "课程"
    },
    {
      value: 1,
      label: "物品"
    },
    {
      value: 2,
      label: "费用"
    },
    {
      value: 4,
      label: "充值卡"
    }
  ];
}

export function GetCheckOnLogStatus() {
  return [
    {
      value: 0,
      label: "考勤"
    },
    {
      value: 1,
      label: "考勤(记上课)"
    },
    {
      value: 2,
      label: "考勤(已点名)"
    },
    {
      value: 3,
      label: "考勤(撤销记上课)"
    }
  ];
}

export function GetWeek2() {
  return [
    {
      value: 1,
      label: "周一"
    },
    {
      value: 2,
      label: "周二"
    },
    {
      value: 3,
      label: "周三"
    },
    {
      value: 4,
      label: "周四"
    },
    {
      value: 5,
      label: "周五"
    },
    {
      value: 6,
      label: "周六"
    },
    {
      value: 0,
      label: "周日"
    }
  ];
}

export function GetStudentAccountRechargeLogType() {
  return [
    {
      value: 0,
      label: "账户充值"
    },
    {
      value: 1,
      label: "账户退款"
    },
    {
      value: 2,
      label: "账户支出"
    },
    {
      value: 3,
      label: "退款至账户"
    },
    {
      value: 4,
      label: "推荐有奖(注册)"
    },
    {
      value: 5,
      label: "推荐有奖(报名/续费)"
    },
    {
      value: 6,
      label: "多支付(报名/续费)"
    },
    {
      value: 7,
      label: "多支付(导入学员课程)"
    },
    {
      value: 8,
      label: "多支付(订单作废)"
    },
    {
      value: 9,
      label: "导入学员"
    },
    {
      value: 10,
      label: "导入学员课程"
    },
    {
      value: 11,
      label: "转课"
    },
    {
      value: 12,
      label: "修改点名记录"
    },
    {
      value: 13,
      label: "考勤记上课"
    },
    {
      value: 14,
      label: "上课点名"
    },
    {
      value: 15,
      label: "扫码扣课时"
    },
    {
      value: 16,
      label: "超上课时标记处理"
    },
    {
      value: 17,
      label: "快速扣课时"
    },
    {
      value: 18,
      label: "批量扣课时"
    },
    {
      value: 19,
      label: "撤销考勤记上课"
    },
    {
      value: 20,
      label: "撤销上课点名"
    },
    {
      value: 21,
      label: "在线购充值卡"
    }
  ];
}

export function GetStudentAccountCardExStartType() {
  return [
    {
      value: 0,
      label: "从购卡日开始"
    },
    {
      value: 1,
      label: "从第一次使用此卡上课开始"
    }
  ];
}
export function GetStudentAccountCardExType() {
  return [
    {
      value: 0,
      label: "月"
    },
    {
      value: 1,
      label: "年"
    }
  ];
}

export function GetStudentAccountCardLimitBuyType() {
  return [
    {
      value: 0,
      label: "月"
    },
    {
      value: 1,
      label: "年"
    }
  ];
}

export function GetDeDayUnit() {
  return [
    {
      value: 1,
      label: "天"
    },
    {
      value: 2,
      label: "月"
    }
  ];
}

export function GetDiscountType() {
  return [
    {
      value: 1,
      label: "直减"
    },
    {
      value: 2,
      label: "折扣"
    }
  ];
}

export function GetGoodsInventoryType() {
  return [
    {
      value: 0,
      label: "入库"
    },
    {
      value: 1,
      label: "销售"
    },
    {
      value: 3,
      label: "订单作废"
    },
    {
      value: 4,
      label: "初始化库存"
    },
    {
      value: 5,
      label: "编辑库存(入库)"
    },
    {
      value: 6,
      label: "编辑库存(出库)"
    },
    {
      value: 7,
      label: "销售退单"
    },
    {
      value: 8,
      label: "库存盘点"
    },
    {
      value: 9,
      label: "扣减库存"
    }
  ];
}

export function GetAllUserJobs() {
  return [
    {
      value: 0,
      label: "全职"
    },
    {
      value: 1,
      label: "兼职"
    },
    {
      value: 2,
      label: "离职"
    }
  ];
}



// WEBPACK FOOTER //
// ./src/api/api.js